export const locale = {
    lang: "es-ES",
    data: {
        ADD_CREDIT_CARD: {
            TITLE: "Añadir nueva tarjeta de crédito",
            NUMBER: {
                LABEL: "Número de tarjeta",
                ERROR: "Número de tarjeta inválido"
            },
            HOLDER: {
                LABEL: "Nombre en la tarjeta",
                ERROR: "Nombre en la tarjeta inválido"
            },
            EXPIRY: {
                LABEL: "Fecha de caducidad",
                PLACE_HOLDER: "MM/AA",
                ERROR: "Fecha de caducidad inválida"
            },
            SECURITY_CODE: {
                LABEL: "CVV",
                ERROR: "CVV inválido"
            },
            PHONE: {
                LABEL: "Teléfono",
                ERROR: "Teléfono inválido"
            },
            ADD_BUTTON: "Guardar",
            IS_DEFAULT: "Usar como predeterminado",
            CANCEL_BUTTON: "Cancelar"
        }
    }
};
